const Text = {
  baseStyle: {
    color: 'gray.700',
  },
};

export default Text;
